import { currentTzDate, formatTzDate } from 'Data/format.js'

export function shouldShow(state, date, time_zone_id) {
  let isToday =
    typeof date !== 'undefined' &&
    formatTzDate(currentTzDate(time_zone_id), 'yyyy-MM-dd', time_zone_id) ===
      date.split('T')[0]
  return state === 'SCHEDULED' && isToday
}
